// The visual viewport excludes the iPad keyboard and follows Safari's browser chrome.
export const visibleViewport = () => {
	const viewport = window.visualViewport;
	return {
		left: viewport?.offsetLeft || 0,
		top: viewport?.offsetTop || 0,
		width: viewport?.width || window.innerWidth,
		height: viewport?.height || window.innerHeight,
	};
};

// An anchor can move without resizing when a neighbouring filter animates.
// Track its geometry while the popup is open, writing styles only after a change.
export const trackFloatingAnchor = (anchor, onMove) => {
	let frame;
	let previousGeometry;
	let stopped = false;
	const check = () => {
		frame = undefined;
		if (stopped || !anchor.isConnected) return;
		const rect = anchor.getBoundingClientRect();
		const viewport = visibleViewport();
		const geometry = [rect.left, rect.top, rect.width, rect.height, viewport.left, viewport.top, viewport.width, viewport.height];
		if (!previousGeometry || geometry.some((value, index) => value !== previousGeometry[index])) {
			previousGeometry = geometry;
			onMove();
		}
		if (!stopped) frame = requestAnimationFrame(check);
	};
	check();
	return () => {
		stopped = true;
		if (frame !== undefined) cancelAnimationFrame(frame);
	};
};

export const fitFloatingPanel = (anchor, size, viewport = visibleViewport(), gap = 8) => {
	const margin = 8;
	const width = Math.min(size.width, Math.max(0, viewport.width - margin * 2));
	const maxHeight = Math.max(0, viewport.height - margin * 2);
	const height = Math.min(size.height, maxHeight);
	const minLeft = viewport.left + margin;
	const minTop = viewport.top + margin;
	const right = viewport.left + viewport.width - margin;
	const bottom = viewport.top + viewport.height - margin;
	let top = anchor.bottom + gap;
	if (top + height > bottom) top = anchor.top - gap - height;
	return {
		position: 'fixed',
		left: `${Math.max(minLeft, Math.min(anchor.left, right - width))}px`,
		top: `${Math.max(minTop, Math.min(top, bottom - height))}px`,
		width: `${width}px`,
		maxHeight: `${maxHeight}px`,
		right: 'auto',
		bottom: 'auto',
	};
};
